<template>
    <v-col cols="12" class="pr-6">        
        <v-row align="center" justify="space-between">
            <v-col
                cols="12"
                class="py-0 px-6"
                v-for="(row, h) in matrix"
                :key="'row-'+h"
            >
                <v-row
                    class="fill-height mb-12"
                    align="center"
                    justify="start"
                >
                    <v-col
                        class="customCols"
                        v-for="(avatarPack, k) in row"
                        :key="'avatarP-'+k"
                    >
                        <AvatarPack :avatarPack="avatarPack" v-on:favorite="verifyFavorite" v-on:toBuy="toBuy" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            style="height: 15vh"
            align="center"
            justify="center"
            v-if="!favoriteView && matrix.length>0"
        >
            <v-img
                :src="require('../../assets/img/arrows/flecha-volver.svg')"
                elevation="6"
                contain
                :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                style="align-items: center; margin-right: 1.5vw; cursor: pointer;"
                @click="previous"
            >
                <p class="button-next-2-text-2">{{ $t('store.previous') }}</p>
            </v-img>
            <v-col cols="12" md="2">
                <span class="page-number">
                    {{ (currentPage + 1) }}
                </span>
                <span class="page-total-number">
                    {{ $t('store.of') + totalPages }}
                </span>
            </v-col>
            <v-img
                :src="require('../../assets/img/arrows/flecha-siguiente.svg')"
                elevation="6"
                contain
                :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                style="align-items: center; cursor: pointer;"
                @click="next"
            >
                <p class="button-next-2-text-1">{{ $t('store.next') }}</p>
            </v-img>
        </v-row>
    </v-col>
</template>

<script>

import { mapState } from 'vuex'
import AvatarPack from './AvatarPack.vue'
import AvatarPackService from '../../services/avatarPack'
import UserAvatarService from '../../services/userAvatar'
import AvatarFavoriteService from '../../services/avatarFavorite'

export default {
    props: {
        favoriteView: { type: Boolean, default: false },
        reload: { type: Number, default: 0 },
        search: { type: String, default: '' }
    },
    components: {
        AvatarPack
    },
    data() {
        return {
            avatarPacks: [],
            currentPage: 0,
            favorites: null,
            purchases: null,
            totalPages: 0
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        matrix() {
            if (!this.purchases) {
                return this.listToMatrix([], 1)
            }
            if (!this.favorites) {
                return this.listToMatrix([], 1)
            }
            const avatars = this.avatarPacks.filter( (item) => {
                return item.avatarDTOList.length.toString().includes(this.search) || item.price.toString().includes(this.search)
            })
            // Verify purchase
            const storeAvatarPacks = []
            avatars.forEach(elementFromList => {
                const avatarPackFromList = elementFromList
                avatarPackFromList.purchased = this.purchases.some(elementFromPurchased => {
                    return elementFromPurchased.id === elementFromList.id
                })
                storeAvatarPacks.push(avatarPackFromList)
            });
            // Verify favorite
            const storeAvatarPacksFavoriteFilter = []
            storeAvatarPacks.forEach(elementFromList => {
                const avatarPackFromList = elementFromList
                avatarPackFromList.favorite = this.favorites.some(elementFromPurchased => {
                    return elementFromPurchased.id === avatarPackFromList.id
                })
                storeAvatarPacksFavoriteFilter.push(avatarPackFromList)
            });
            // Verify favorite view
            let finalArray = storeAvatarPacksFavoriteFilter
            if (this.favoriteView) {
                finalArray = storeAvatarPacksFavoriteFilter.filter( (item) => item.favorite === true)
            }
            if (this.$vuetify.breakpoint.xs) {
                return this.listToMatrix(finalArray, 1)
            }
            if (this.$vuetify.breakpoint.sm) {
                return this.listToMatrix(finalArray, 2)
            }
            if (this.$vuetify.breakpoint.md) {
                return this.listToMatrix(finalArray, 3)
            }
            if (this.$vuetify.breakpoint.lg) {
                return this.listToMatrix(finalArray, 4)
            }
            return this.listToMatrix(finalArray, 5)
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        getActiveAvatars() {
            AvatarPackService.getPage(this.currentPage, 15)
                .then((response) => {
                    this.totalPages = response.content.totalPages
                    this.setPayAvatars(response.content.content)
                })
                .catch((error) => console.error(error))
        },
        getFavorites() {
            this.$emit('loaded', false)
            this.favorites = null
            AvatarFavoriteService.getAllByUser(
                this.user.id
            )
            .then((response) => {
                this.$emit('loaded', true)
                this.favorites = response.content
            })
            .catch((error) => console.error(error))
        },
        getUserAvatarPacks() {
            UserAvatarService.getAllPackByUser(
                this.user.id
            )
            .then((response) => {
                this.purchases = response.content
            })
            .catch((error) => console.error(error))
        },
        listToMatrix(list, elementsPerSubArray) {
            const matrix = []
            let i
            let k

            for (i = 0, k = -1; i < list.length; i+=1) {
                if (i % elementsPerSubArray === 0) {
                    k+=1;
                    matrix[k] = [];
                }
                matrix[k].push(list[i])
            }
            return matrix
        },
        async loadData() {
            await this.getFavorites()
            await this.getUserAvatarPacks()
            await this.getActiveAvatars()
        },
        next() {
            if (this.currentPage < (this.totalPages - 1)) {
                this.currentPage += 1
                this.avatarPacks = []
                this.getActiveAvatars()
            }
        },
        previous() {
            if (this.currentPage > 0) {
                this.currentPage -= 1
                this.avatarPacks = []
                this.getActiveAvatars()
            }
        },
        verifyFavorite(data) {
            const currentFavorites = JSON.parse(JSON.stringify(this.favorites))
            this.favorites = null
            setTimeout(() => {
                this.filterFavorite(data, currentFavorites)
            }, 500)
        },
        filterFavorite(data, currentFavorites) {
            const favorites = currentFavorites
            if (data.favorite) {
                favorites.push( { id: data.id } )
                this.favorites = favorites
            } else {
                this.favorites = favorites.filter( (item) => item.id !== data.id )
            }
        },
        setPayAvatars(data) {
            this.avatarPacks = data.filter( (item) => item.avatarPackType === 'PAY')
        },
        toBuy (avatarPack) {
            this.avatarPacks.forEach((avatarPackInList) => {
                if (avatarPackInList.id === avatarPack.id) {
                    this.$emit('purchase', avatarPack)
                }
            })
        }
    },
    watch: {
        reload() {
            this.getUserAvatarPacks()
            this.getFavorites()
        }
    }
}
</script>
<style scoped>
.customCols {
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
}
@media (min-width: 600px) {
    .customCols {
        width: 50%;
        max-width: 50%;
        flex-basis: 50%;
    }
}
@media (min-width: 960px) {
    .customCols {
        width: 33%;
        max-width: 33%;
        flex-basis: 33%;
    }
}
@media (min-width: 1264px) {
    .customCols {
        width: 25%;
        max-width: 25%;
        flex-basis: 25%;
    }
}
@media (min-width: 1904px) {
    .customCols {
        width: 20%;
        max-width: 20%;
        flex-basis: 20%;
    }
}

.button-next-2-text-1 {
    color: white;
    font-size: 1vw;
    margin-bottom: 0;
    font-family: 'Open Sans';
}
.button-next-2-text-2 {
    color: #ff6f3a;
    font-size: 1vw;
    margin-bottom: 0;
    font-family: 'Open Sans';
}
.page-number {
    font-size: 1vw;
}
.page-total-number {
    color: #D7C5B0;
    font-size: 1vw;
}

@media (max-width: 1263px) {
    .button-next-2-text-1 {
        font-size: 3vw;
    }
    .button-next-2-text-2 {
        font-size: 3vw;
    }
    .page-number {
        font-size: 3vw;
    }
    .page-total-number {
        font-size: 3vw;
    }
}
</style>